export default function* watchNavigate() {
  yield null;
}
